import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;

  @media (max-height: 500px) and (orientation: landscape) {
    top: 8px;
  }
`;

export const Main = styled.h1`
  font-family: 'Adam', sans-serif;
  font-size: clamp(16px, 2.5vw, 24px);
  font-weight: 500;
  letter-spacing: 6px;
  color: #fff;
  text-shadow:
    0 0 30px rgba(255, 200, 100, 0.4),
    0 0 60px rgba(255, 150, 50, 0.2);
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    font-size: 16px;
    letter-spacing: 4px;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    font-size: clamp(13px, 3vw, 19px);
  }
`;

export const Subtitle = styled.p`
  font-family: 'Adam', sans-serif;
  font-size: clamp(13px, 1.8vw, 18px);
  font-weight: 300;
  letter-spacing: 6px;
  color: rgba(255, 200, 100, 1);
  text-transform: uppercase;
  margin-top: 6px;
  margin-bottom: 0;
  padding: 0;

  @media (max-width: 768px) {
    font-size: 11px;
    letter-spacing: 3px;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    font-size: clamp(8px, 1.5vw, 13px);
    margin-top: 4px;
  }
`;
